import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import { useTranslation } from 'react-i18next';
import CommonButton from '../../components/CommonButton';
import Context from '../../provider';
import React, { useContext } from 'react';

export default function MessageDialog() {
  const { msgDialog, dispatch } = useContext(Context);
  const { t } = useTranslation();

  const handleClose = () => {
    dispatch({
      type: 'SET_MESSAGE_DIALOG',
      payload: {
        open: false,
        title: null,
        message: null,
        code: null
      }
    });
  };

  function PaperComponent() {
    return (
      <div className='message-dialog'>
        {msgDialog.title && <h1>{msgDialog.title}</h1>}
        <div className='content' dangerouslySetInnerHTML={{ __html: msgDialog.message }} />
        <div className='ctrls'>
          <CommonButton
            onClick={handleClose}
            text={t('action.close')}
            minWidth={150}
            minHeight={20}
            padding={'10px'}
          />
        </div>
      </div>
    );
  }

  return (
    <Dialog
      className='message-dialog'
      open={msgDialog?.open ?? false}
      onClose={ handleClose }
    >
      {msgDialog?.title && <DialogTitle>{msgDialog?.title}</DialogTitle>}
      <DialogContent dangerouslySetInnerHTML={{ __html: msgDialog.message }} />
      <DialogActions>
        <CommonButton
          onClick={handleClose}
          text={t('action.close')}
          minWidth={150}
          minHeight={20}
          padding={'10px'}
        />
      </DialogActions>
    </Dialog>
  );
}